export default "__VITE_ASSET__BzXrNPgX__"